import $ from 'jquery'
import UriHandler from 'aria-viewer/utils/uriHandler'
import { getEnv } from 'aria-viewer/utils/environment'

//This class will manage calls to the API
//This should take the pressure off of aps to know how to communicate with the API
var ApiResource = function() {
    this.baseAPIURL = getEnv('REACT_APP_BASE_API_URL') + '/'
}

ApiResource.prototype = {
    load: function(url, params, cb) {
        this._request(url, params, cb)
    },

    loadVideo: function(options) {
        var id = options['id'],
            urlParams = options['urlParams'],
            cb = options['cb']

        this._request('videos/' + id, urlParams, cb)
    },

    /**
     * Strip Domain from URL
     * This invokes youvisit.com proxy to fight CORS
     */
    stripDomain: function(url) {
        return !UriHandler.isInSameSubDomain(url, window.location.href) ? UriHandler.appendCorsQueryParam(url) : url
    },

    _request: function(resourceUrl, params, cb) {
        var url = this.baseAPIURL + resourceUrl

        $.ajax({
            url: url,
            data: params,
            success: function(response) {
                this.data = response.data

                // Let's append the query param cors=anonymous is the request url
                // doesn't match the current url we're on
                if (!UriHandler.isInSameSubDomain(url, window.location.href)) {
                    response.data = (response.data || []).map(function(r) {
                        return Object.assign(r, {
                            url: UriHandler.appendCorsQueryParam(r.url),
                        })
                    })
                }

                cb(response)
            },
            error: function() {
                console.error('Failed to contact API')
            },
        })
    },
}

export default ApiResource
